// services/firestore/members.ts — Reads for an org's members
// sub-collection + the related org_seat_allocations collection.

import {
  collection,
  getDocs,
  query,
  where,
} from 'firebase/firestore';
import { db } from '@/services/firebase';
import type { LicenseOrgMembership, SeatAllocation } from '@/types/domain';

export async function listActiveMembers(
  orgId: string,
): Promise<LicenseOrgMembership[]> {
  const q = query(
    collection(db, 'license_orgs', orgId, 'members'),
    where('status', '==', 'active'),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data() as Record<string, unknown>;
    return {
      uid: (data.uid as string | undefined) ?? d.id,
      orgId,
      role:
        data.role === 'owner' || data.role === 'admin'
          ? (data.role as 'owner' | 'admin')
          : 'member',
      joinedAt: (data.joinedAt as LicenseOrgMembership['joinedAt']) ?? null,
      invitedBy: (data.invitedBy as string | null) ?? null,
      status: 'active',
    };
  });
}

export async function listActiveSeatAllocations(
  orgId: string,
): Promise<SeatAllocation[]> {
  const q = query(
    collection(db, 'org_seat_allocations'),
    where('orgId', '==', orgId),
    where('status', '==', 'active'),
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data() as Record<string, unknown>;
    return {
      id: d.id,
      orgId,
      uid: (data.uid as string | undefined) ?? '',
      productId: (data.productId as string | undefined) ?? '?',
      allocatedAt:
        (data.allocatedAt as SeatAllocation['allocatedAt']) ?? null,
      allocatedBy: (data.allocatedBy as string | null) ?? null,
      revokedAt:
        (data.revokedAt as SeatAllocation['revokedAt']) ?? null,
      status: 'active',
    };
  });
}
